var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { PatientInvoiceSettlement } from '../enums/patient-invoice-settlement.enum.js';
import { PatientInvoiceStatus } from '../enums/patient-invoice-status.enum.js';
export class OfficePatientInvoicePatientSummaryDto {
    firstName;
    lastName;
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoicePatientSummaryDto.prototype, "firstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoicePatientSummaryDto.prototype, "lastName", void 0);
export class OfficePatientInvoiceListItemDto {
    id;
    /** Lifecycle only (ADR-0043). */
    status;
    settlement;
    /** Offener Betrag in cents. */
    openAmountCents;
    /** Versendet. */
    sentAt;
    identity;
    documentId;
    issuedAt;
    dueDate;
    /**
     * Highest dunning stage of the letters issued for this invoice, or `null` if
     * never dunned. A raw fact for the frontend "Mahnstatus" posture — the backend
     * stays clock-dumb and never derives a time-dependent posture itself.
     */
    currentDunningStage;
    /**
     * ISO timestamp of the most recently issued dunning letter for this invoice,
     * or `null` if never dunned. Subtitle date for the "Mahnstatus" posture.
     */
    lastDunnedAt;
    /**
     * Mahnsperre (per-invoice dunning block, PRD #988). `dunningBlockReason` is
     * non-null while a block is set (free-text); `dunningBlockedUntil` is `null`
     * for an indefinite block or a date for a temporary one. Together they feed
     * the frontend `dunningPosture` `blocked` branch (label "Mahnsperre", subline
     * "bis DD.MM." when temporary) — the backend stays clock-dumb and never
     * derives the time-dependent posture itself.
     */
    dunningBlockReason;
    dunningBlockedUntil;
    createdAt;
    totalGross;
    currency;
    patientId;
    patient;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficePatientInvoiceListItemDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficePatientInvoiceListItemDto.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficePatientInvoiceListItemDto.prototype, "settlement", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OfficePatientInvoiceListItemDto.prototype, "openAmountCents", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "sentAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "identity", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "documentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "issuedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "dueDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "currentDunningStage", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "lastDunnedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "dunningBlockReason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficePatientInvoiceListItemDto.prototype, "dunningBlockedUntil", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], OfficePatientInvoiceListItemDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OfficePatientInvoiceListItemDto.prototype, "totalGross", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficePatientInvoiceListItemDto.prototype, "currency", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficePatientInvoiceListItemDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    Type(() => OfficePatientInvoicePatientSummaryDto),
    __metadata("design:type", OfficePatientInvoicePatientSummaryDto)
], OfficePatientInvoiceListItemDto.prototype, "patient", void 0);
//# sourceMappingURL=office-patient-invoice-list-item.response.dto.js.map